<section id="login-microempresario" class="login-micro">
  <app-header-public variant="v2" [showAuthButtons]="false" [showRegisterButton]="false"></app-header-public>

  <div class="login-micro__vigilado" aria-hidden="true">
    <img class="login-micro__vigilado-img" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <main class="login-micro__main">
    <div class="login-micro__hero">
      <div class="login-micro__bg" aria-hidden="true"></div>
      <div class="login-micro__visual-mobile" aria-hidden="true">
        <span class="login-micro__bubble login-micro__bubble--tl-lg"></span>
        <span class="login-micro__bubble login-micro__bubble--tl-sm"></span>
        <img class="login-micro__visual-mobile-img" src="assets/img/login/login-microempresario-mobile.png" alt="" />
      </div>

      <h1 class="login-micro__hero-title">Inicio de sesión</h1>

      <span class="login-micro__bubble login-micro__bubble--br-lg login-micro__bubble--desktop"
        aria-hidden="true"></span>
      <span class="login-micro__bubble login-micro__bubble--br-sm login-micro__bubble--desktop"
        aria-hidden="true"></span>

      <div class="login-micro__panel">
        <!-- Ancladas al panel: siguen la esquina superior izquierda al redimensionar -->
        <span class="login-micro__bubble login-micro__bubble--tl-lg login-micro__bubble--desktop"
          aria-hidden="true"></span>
        <span class="login-micro__bubble login-micro__bubble--tl-sm login-micro__bubble--desktop"
          aria-hidden="true"></span>

        <form class="login-micro__form" [formGroup]="loginForm" (ngSubmit)="validateForm()" novalidate>
          <div class="login-micro__field" [class.login-micro__field--invalid]="validateField('tipoDocumento')">
            <label class="login-micro__label" for="tipoDocumento">Tipo de documento*</label>
            <select id="tipoDocumento" class="login-micro__control" formControlName="tipoDocumento"
              (change)="validarSelect()" [class.is-invalid]="validateField('tipoDocumento')" required>
              <option value="">Seleccione una opción</option>
              @for (documento of documentos; track documento.idTipoDocIdentidad) {
              <option [value]="documento.idTipoDocIdentidad">
                {{ documento.nombre }}
              </option>
              }
            </select>
            <div class="login-micro__error">Campo obligatorio</div>
          </div>

          <div class="login-micro__field" [class.login-micro__field--invalid]="validateField('numeroDocumento')">
            <label class="login-micro__label" for="numeroDocumento">Número de documento*</label>
            <input id="numeroDocumento" class="login-micro__control" autocomplete="off" type="text"
              maxlength="15" formControlName="numeroDocumento"
              appNumeroDocumentoPorTipo
              [tipos]="documentos"
              idTipoDocControlName="tipoDocumento"
              [class.is-invalid]="validateField('numeroDocumento')" required />
            @if (loginForm.get('numeroDocumento')?.hasError('documentPattern')) {
            <div class="login-micro__error">{{ mensajeErrorNumeroDocumento }}</div>
            } @else {
            <div class="login-micro__error">Campo obligatorio</div>
            }
          </div>

          <div class="login-micro__field" [class.login-micro__field--invalid]="validateField('password')">
            <label class="login-micro__label" for="password">Contraseña*</label>
            <div class="login-micro__password">
              <input id="password" class="login-micro__control" autocomplete="off" maxlength="20"
                [type]="isVisible ? 'text' : 'password'" formControlName="password"
                [class.is-invalid]="validateField('password')" />
              <button class="login-micro__password-toggle" type="button" (click)="showPassword()"
                [attr.aria-label]="isVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </button>
            </div>
            <div class="login-micro__error">
              Campo obligatorio (Debe tener como mínimo 8 caracteres, 1
              mayúscula, 1 minúscula, 1 número y 1 caracter especial
              (&#64;$+#!%*?&-/_.,))
            </div>
          </div>

          <div class="login-micro__actions">
            <a routerLink="/home" fragment="home-crea-cuenta" class="login-micro__btn login-micro__btn--secondary"
              id="btn-login-micro-registrate" (click)="trackLinkCta('Regístrate', 'btn-login-micro-registrate')">
              Regístrate
            </a>
            <button type="submit" class="login-micro__btn login-micro__btn--primary" id="btn-login-micro-iniciar">
              Inicia sesión
            </button>
          </div>
        </form>

        <nav class="login-micro__links" aria-label="Acciones de cuenta">
          <a routerLink="/recordar" class="login-micro__link" id="btn-login-olvidaste"
            (click)="trackLinkCta('¿Olvidaste tu contraseña?', 'btn-login-olvidaste')">
            ¿Olvidaste tu contraseña?
          </a>
          <a routerLink="/desbloquear" class="login-micro__link" id="btn-login-desbloquear"
            (click)="trackLinkCta('Desbloquea tu usuario', 'btn-login-desbloquear')">
            Desbloquea tu usuario
          </a>
        </nav>
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</section>